import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import "./App.css";
import Header from "./components/Header/Header";
import Footer from "./components/Footer/Footer";
import ProductsPage from "./pages/ProductsPage/ProductsPage";
import ProductDetailPage from "./pages/ProductDetailPage/ProductDetailPage";
import CartPage from "./pages/CartPage/CartPage";
import CheckoutPage from "./pages/CheckoutPage/CheckoutPage";
import OrderSuccessPage from "./pages/OrderSucessPage/OrderSuccessPage";
import AboutPage from "./pages/AboutPage/AboutPage";
import ContactsPage from "./pages/ContactsPage/ContactsPage";
import DigitalProducts from "./pages/DigitalProductsPage/DigitalProducts";
import AdminDashboard from "./pages/AdminDashboardPage/AdminDashboardPage";
import UserForm from "./pages/UserForm/UserForm";
import ProductForm from "./pages/ProductForm/ProductForm";
import OrderForm from "./pages/OrderForm/OrderForm";
import LoginPage from "./pages/LoginPage/LoginPage";
import Register from "./pages/RegisterPage/RegisterPage";
import { AuthProvider } from "./context/AuthContext";
import { CartProvider } from "./context/CartContext";
import MyOrdersPage from "./pages/MyOrdersPage/MyOrdersPage";
import ProfilePage from "./pages/ProfilePage/ProfilePage";
import MyOrderDetailsPage from "./pages/MyOrderDetailsPage/MyOrderDetailsPage";
import PrivacyTerms from "./pages/PrivacyTerms/PrivacyTerms";
import RecoverPassword from "./pages/RecoverPassword/RecoverPassword";
import ResetPassword from "./pages/ResetPassword/ResetPassword";
import ServiceForm from "./pages/ServiceForm/ServiceForm";
import NewsletterVerification from "./pages/NewsletterVerification/NewsletterVerification";
import NewsletterUnsubscribe from "./pages/NewsletterUnsubscribe/NewsletterUnsubscribe";
import AuthVerification from "./pages/AuthVerification/AuthVerification";
import MBWayPaymentPage from './pages/CheckoutPage/MBWayPaymentPage';
import MultibancoPaymentPage from './pages/CheckoutPage/MultibancoPaymentPage';
import ServicePage from "./pages/ServicePage/ServicePage";
import ServiceDetailPage from "./pages/ServiceDetailPage/ServiceDetailPage";
import SitemapPage from "./pages/SitemapPage";

function App() {
  return (
      <AuthProvider>
        <CartProvider>
          <Router>
            <div className="App">
              <Header />
              <main className="main-content">
                <Routes>
                  <Route path="/" element={<AboutPage />} />
                  <Route path="/sobre" element={<AboutPage />} />
                  <Route path="/produtos" element={<ProductsPage />} />
                  <Route path="/produtos/:id" element={<ProductDetailPage />} />
                  <Route path="/carrinho" element={<CartPage />} />
                  <Route path="/checkout" element={<CheckoutPage />} />
                  <Route path="/order-success" element={<OrderSuccessPage />} />
                  <Route path="/contactos" element={<ContactsPage />} />
                  <Route path="/produtos-digitais" element={<DigitalProducts />} />
                  <Route path="/admin-dashboard" element={<AdminDashboard />} />
                  <Route path="/admin-dashboard/create-user" element={<UserForm />} />
                  <Route
                    path="/admin-dashboard/create-product"
                    element={<ProductForm />}
                  />
                  <Route
                    path="/admin-dashboard/create-order"
                    element={<OrderForm />}
                  />
                  <Route
                    path="/admin-dashboard/edit-user/:id"
                    element={<UserForm />}
                  />
                  <Route
                    path="/admin-dashboard/edit-product/:id"
                    element={<ProductForm />}
                  />
                  <Route
                    path="/admin-dashboard/edit-order/:id"
                    element={<OrderForm />}
                  />
                  <Route
                    path="/admin-dashboard/edit-service/:id"
                    element={<ServiceForm />}
                  />
                  <Route
                    path="/admin-dashboard/create-service"
                    element={<ServiceForm />}
                  />
                  <Route path="/login" element={<LoginPage />} />
                  <Route path="/register" element={<Register />} />
                  <Route path="/auth/verify" element={<AuthVerification />} />
                  <Route path="/minhas-encomendas" element={<MyOrdersPage />} />
                  <Route path="/minhas-encomendas/:id" element={<MyOrderDetailsPage />} />
                  <Route path="/perfil" element={<ProfilePage />} />
                  <Route path="/termos-privacidade" element={<PrivacyTerms />} />
                  <Route path="/recuperar-senha" element={<RecoverPassword />} />
                  <Route path="/recuperar-senha/:token" element={<ResetPassword />} />
                  <Route path="/newsletter/verify" element={<NewsletterVerification />} />
                  <Route path="/newsletter/unsubscribe" element={<NewsletterUnsubscribe />} />
                  <Route path="/mbway-payment" element={<MBWayPaymentPage />} />
                  <Route path="/multibanco-payment" element={<MultibancoPaymentPage />} />
                  <Route path="/servicos" element={<ServicePage />} />
                  <Route path="/servicos/:id" element={<ServiceDetailPage />} />
                  <Route path="/sitemap" element={<SitemapPage />} />
                </Routes>
              </main>
              <Footer />
            </div>
          </Router>
        </CartProvider>
      </AuthProvider>
  );
}

export default App;
